export default (theme) => ({
  pageContent: {
    marginLeft: 220,
  }
});
